'use client';

import { useGlobalLoadingAtom } from '@/state';
import useIsMovingToOtherPath from '@/utils/useIsMovingToOtherPath';
import Link, { type LinkProps } from 'next/link';

interface LoadingLinkProps<RouteType> extends LinkProps<RouteType> {
  enableGlobalLoading?: boolean;
  children?: React.ReactNode;
}

// 画面遷移中にローディングアニメーションを差し込むLinkコンポーネント
function LoadingLink<RouteType>({
  enableGlobalLoading = true,
  onClick,
  href,
  children,
  ...props
}: LoadingLinkProps<RouteType>) {
  const [_, startGlobalLoading] = useGlobalLoadingAtom();
  const isMovingToOtherPath = useIsMovingToOtherPath();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // 元のonClickがある場合は実行
    if (onClick) {
      onClick(e);
    }

    // ローディングフラグがtrueで、かつ異なるパスへの移動の場合のみローディング開始
    if (enableGlobalLoading && isMovingToOtherPath(href)) {
      startGlobalLoading();
    }
  };

  return (
    <Link href={href} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
}

export default LoadingLink;
